import React, {Component} from 'react';
import {Redirect} from 'react-router';
import {connect} from 'react-redux';
import {message, AutoComplete, Icon, Input, Button, Modal} from 'antd';
import './app.less';
import {changeSearchDetail} from '../../../store/reduces/frontEnd';
import Vip from '../../../components/frontEnd/vip/vip';

function UserBlock({fullName}) {
  return fullName
    ? <span className="app-topbar__user-name">{fullName}</span>
    : <span className="app-topbar__user-not">您还未登录，请登录</span>;
}
@connect(
  (state) => (state),
  {changeSearchDetail},
)
export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchContent: '', // 搜索的内容
      dataSource: [], // 搜索列表
      goodsType: ['软件', '硬件', '流量产品'], // 商品类型列表
      type: null, // 查询类型
      id: 'null', // property或category
      ModalText: '是否登出当前账户？', // 登出弹窗的内容
      visible: false, // 空值推出弹窗的显示和隐藏
      confirmLoading: false, // 确定按钮的loading
      fullName: null, // 用户名
      redirect: false, // 空值重定向到登录页
      level: 0, // 折扣等级

      sourceCMS: '', // 来源标识默认''

    };
  }

  componentWillMount() {
    if (window.common.loginOut(this)) {
      if (!window.localStorage.getItem('PKEY')) {
        this.props.history.push('/login');
      } else {
        const level = window.localStorage.getItem('level');
        const list = window.localStorage.getItem('dataSource');
        const dataSource = list !== null ? JSON.parse(list) : [];
        const fullName = window.localStorage.getItem('fullName');

        const sourceCMS = window.localStorage.getItem('sourceCMS') || '';

        if (this.props.location.pathname === '/searchDetail') {
          this.setState(this.props.location.state);
        }
        this.setState({
          dataSource,
          fullName,
          level,
          sourceCMS
        });
      }
    }
  }

  componentWillReceiveProps(props) {
    let info = {};
    if (props.location.pathname === '/searchDetail') {
      info = props.location.state;
    } else {
      info = {id: null, type: null, searchContent: null};
    }
    this.setState(info);
  }

  // 跳转到指定页面
  link = (link) => {
    if (this.props.location.pathname !== link) {
      this.props.history.push(link);
    }
  }

  // 跳转到搜索页
  toSearchDetail = (type, id, searchContent) => {
    const info = {type, id, searchContent};
    const {dataSource} = this.state;
    if (type === 'search') {
      if (searchContent !== '') { // 获取下拉列表
        const list = dataSource;
        const index = dataSource.indexOf(searchContent);
        list.unshift(searchContent);
        if (index !== -1) {
          list.splice(index + 1, 1);
        } else {
          list.length > 5 ? list.splice(list.length - 1, 1) : null;
        }
        window.localStorage.setItem('dataSource', JSON.stringify(list));
      }
    }
    this.setState(info);
    const other = {
      sortIndex: 1,
      classification: 0,
      pageNumber: 1
    };
    this.props.changeSearchDetail({...info, ...other});
    if (this.props.location.pathname !== '/searchDetail') {
      this.props.history.push('/searchDetail', info);
    } else {
      // 已经在搜索页时，需要手动触发一次 history replace 来更新 state
      this.props.history.replace('/searchDetail', info);
    }
  }

  // 登出
  logout = () => {
    this.setState({ModalText: '登出中,请稍后...', confirmLoading: true});
    const loginName = JSON.parse(window.localStorage.getItem('headParams')).login_name;
    const params = {login_name: loginName};
    window.api('eps.logout', params).then(() => {
      message.success('已登出');
      this.setState({visible: false, confirmLoading: false, ModalText: '是否登出当前账户？'});
      window.localStorage.clear();
      this.props.history.push('/login');
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }

  // 控制Modal
  changeModal = () => {
    this.setState({visible: !this.state.visible});
  }

  // 获取搜索框内容
  getSearchContent = (value) => {
    value !== this.state.searchContent ? this.setState({searchContent: value}) : null;
  }

  render() {
    const {
      redirect, dataSource, searchContent, visible, confirmLoading, ModalText, goodsType, id, fullName, type, level, sourceCMS
    } = this.state;
    if (redirect) return (<Redirect to="/login" />);

    // 当sourceCMS为1时，隐藏顶部操作栏和导航栏
    const isEmbeddedMode = sourceCMS === '1';

    return (
      <div className="app-page">
        {!isEmbeddedMode && (
          <div>
            <div className="app-topbar">
              <div className="app-container app-topbar__inner">
                <a className="app-topbar__home" onClick={(e) => { e.preventDefault(); this.link('/'); }} href="/">
                  <Icon type="home" />
                  <span>首页</span>
                </a>
                <div className="app-topbar__right">
                  <div className="app-topbar__tool">
                    <UserBlock fullName={fullName} />
                    <Vip status={Number(level)} />
                  </div>
                  <nav className="app-topbar__nav">
                    <span onClick={() => this.link('/personalDetails')}>我的账户</span>
                    <span onClick={() => this.link('/orderList')}>我的订单</span>
                    <span onClick={() => this.link('/deviceManagement')}>我的设备</span>
                    <span onClick={this.changeModal}>登出</span>
                  </nav>
                </div>
              </div>
            </div>
            <header className="app-header">
              <div className="app-container app-header__inner">
                <h1 className="app-header__logo" onClick={() => this.link('/')}>
                  <Icon type="code-sandbox" />
                  <span>联拓富商城</span>
                </h1>
                <div className="app-header__main">
                  <ul className="app-header__menu">
                    {goodsType.map((item, index) => (
                      <li
                        key={index}
                        className={type === 'property' && String(index + 1) === String(id) ? 'is-active' : ''}
                        onClick={() => this.toSearchDetail('property', Number(index + 1), '')}
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                  <div className="app-header__search">
                    <AutoComplete
                      dataSource={dataSource}
                      className="app-search"
                      size="large"
                      value={searchContent}
                      onChange={this.getSearchContent}
                      placeholder="搜索商品/套餐"
                      style={{width: '200px'}}
                    >
                      <Input
                        suffix={
                          <Button
                            className="app-search__btn"
                            size="large"
                            type="primary"
                            onClick={() => {
                              if (!searchContent || !searchContent.trim()) {
                                message.error('请输入搜索内容');
                                return;
                              }
                              this.toSearchDetail('search', 0, searchContent);
                            }}
                          >
                            <Icon type="search" />
                          </Button>
                        }
                      />
                    </AutoComplete>
                  </div>
                </div>
              </div>
            </header>
          </div>
        )}
        <main className={`app-main ${isEmbeddedMode ? 'app-main_embedded' : ''}`}>
          <div className="app-container">{this.props.children}</div>
        </main>

        {!isEmbeddedMode && (
          <footer className="app-footer">
            <div className="app-container">©2019 lianfutong.com</div>
          </footer>
        )}

        <Modal
          visible={visible}
          onOk={this.logout}
          confirmLoading={confirmLoading}
          onCancel={this.changeModal}
        >
          <p>{ModalText}</p>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/frontEnd/app/app.jsx